import { type DependencyList, type RefObject, useEffect } from 'react';

const useResizeObserver = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
  deps?: DependencyList
) => {
  useEffect(() => {
    const htmlElement = ref.current;

    const resizeObserver = htmlElement
      ? new ResizeObserver(callback)
      : undefined;

    if (htmlElement) {
      resizeObserver?.observe(htmlElement);
    }

    return () => {
      if (htmlElement) {
        resizeObserver?.unobserve(htmlElement);
      }
    };
  }, deps || []);
};

export default useResizeObserver;
